import React from "react";
import { useSelector } from "react-redux";
import { IRootState } from "../../../../../../reducer/CombineReducer";
import { SchedulingModes } from "../../../CreateSchedule/redux/Types";
import { getMonthsOfTheYear } from "../../GetDataSourceValues";
import { Dropdown } from "../../../../../Common/UI/Index";
import "../Common/Style.scss";

export interface IYearlyConfigViewPropType {
  onFieldChange: (selectedValue: string) => void;
}

/**
 * Component will be rendered for reccurence type yearly. 
 * Responsible for rendering the yearly dropdown component in UI
 */
const YearlyConfigView = (prop: IYearlyConfigViewPropType): JSX.Element => {

  const { onFieldChange } = prop;
  const scheduling = useSelector((state: IRootState) => state.scheduling);
  const { schedulingDetails } = scheduling;
  const { recurrenceData } = schedulingDetails;
  const selectedValue = (recurrenceData && recurrenceData.month) ?
    recurrenceData.month : 1;
  const disabledFields = scheduling.mode === SchedulingModes.VIEW;
  return (
    <div className="yearly-container" data-testid="yearly-container">
      <div className="yearly-container__month-label">In month of</div>
      <Dropdown
        dataSource={getMonthsOfTheYear}
        id="day-week_week_month"
        data-testid="day-week_week_month"
        name="week_month"
        onChange={onFieldChange}
        value={selectedValue}
        disabled={disabledFields}
      />
    </div>);
};

export default YearlyConfigView;

